import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export type Direction = 'ltr' | 'rtl';

export function useDirection(): Direction {
  const { i18n } = useTranslation();
  const direction: Direction = i18n.language === 'ar' ? 'rtl' : 'ltr';

  useEffect(() => {
    document.documentElement.dir = direction;
    document.documentElement.lang = i18n.language;
  }, [direction, i18n.language]);

  return direction;
}
